import React, { CSSProperties, ReactNode, SyntheticEvent } from 'react';
import {
  MenuItem as MUIMenuItem,
  MenuItemProps as MUIMenuItemProps,
  SxProps,
} from '@mui/material';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

type CustomProps = {
  style?: CSSProperties;
};

type AtomMUIProps = {
  classes?: any;
  children?: ReactNode;
  disabled?: boolean;
  selected?: boolean;
  onClick?: (event: SyntheticEvent<any>) => void;
};

type MenuProps = CustomProps & AtomMUIProps;

const sx: SxProps = {
  minHeight: '2.25rem',
  fontWeight: 500,
  fontSize: fonts.md,
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '16px',
  paddingRight: '16px',
  width: 'auto',
  '&.Mui-selected': {
    color: colors.brand.blue,
  },
};

// forwardRef needed to forward ref passed by Select component
const MenuItem = React.forwardRef((props: MenuProps, ref: React.Ref<any>) => {
  const MUIProps: MUIMenuItemProps = props;

  return <MUIMenuItem {...MUIProps} sx={sx} ref={ref} />;
});

export default MenuItem;
